/**
 * 功能: slide预览
 */
<template lang="pug">
  div(style='height: 100%;')
    .container
      .headerline
        #headerline
      .header(@mousemove="goheader" @mouseleave="leaveheader" :class="[ isShow ? showcss : '' ]")
        Header(:glossaryArr="glossaryArr" :chartOutline="chartOutline" :outlineWbs="outlineWbs" :brief="brief" :updateLog="updateLog")
      .main
        Slide(:brief="brief" @mode="changeHeader")
      footerFoot
</template>

<script>
import Header from './previewSlide/header'
import Slide from './previewSlide/slide'
import api from '@/apis/slide'
import apiGlossary from '@/apis/glossary'
import apiBrief from '@/apis/brief'
import footerFoot from './previewSlide/footer'
export default {
  name: 'previewSlide',
  components: {
    Header, Slide, footerFoot
  },
  data () {
    return {
      glossaryArr: [],
      chartOutline: [],
      slideArr: [],
      outlineWbs: [],
      brief: {},
      outlineTiling: [],
      isShow: false,
      showcss: 'fullwebpage-header',
      updateLog: []
    }
  },
  mounted () {
    // 获取slide的数据
    const id = this.$route.query.id
    if (id) {
      api.getSlide({ id }).then(res => {
        if (res) {
          this.outlineWbs.push(this.reWbsAndGraphic(res.data))
          this.chartOutline = this.creditLine(this.outlineWbs[0])
          this.outlineTiling = this.makeOutline(res.data.children)
          for (const i of this.outlineTiling) {
            if (i.slide.length > 0) {
              for (const j of i.slide) {
                this.slideArr.push(j)
              }
            }
          }
        }
        this.$bus.$emit('slideArr', this.slideArr)
      })
      apiGlossary.getGlossaryByBriefId({ brief: id }).then(r => {
        const glossaryArr = []
        r.data.map(glossary => {
          glossaryArr.push({ noun: glossary.noun, explanation: glossary.explanation })
        })
        glossaryArr.sort(function (item1, item2) {
          return item1.noun.localeCompare(item2.noun, 'zh-CN')
        })
        this.glossaryArr = glossaryArr
      })
      apiBrief.getBrief({ id }).then(res => {
        this.brief = res.data
      })
      apiBrief.getBriefLogList({ id }).then(doc => {
        this.updateLog = doc.data
      })
    }
  },
  methods: {
    // 生成图标目录和
    reWbsAndGraphic (outlines, wbs = '', attachment = {}) {
      if (outlines && outlines.children.length > 0) {
        outlines.children.map((outline, index) => {
          outline.wbs = wbs + (index + 1) + '.'
          const desc = outline.wbs.split('.')[0]
          const keys = Object.keys(attachment)
          if (!keys.includes('ill' + desc)) {
            attachment['ill' + desc] = []
          }
          if (!keys.includes('table' + desc)) {
            attachment['table' + desc] = []
          }
          if (outline && outline.slide && outline.slide.length > 0) {
            outline.slide.map(element => {
              if (element && element.elements.length > 0) {
                element.elements.map(item => {
                  // 类型：0=图片，1=政策；2=Size；3=专家说
                  if (item.attachment._class === 0) {
                    attachment['ill' + desc].push(item)
                    item.explain = `图 ${desc}-${attachment['ill' + desc].length}`
                  } else if (item.attachment._class === 1) {
                    attachment['table' + desc].push(item)
                    item.explain = `表 ${desc}-${attachment['table' + desc].length}`
                  } else if (item.attachment._class === 2) {
                    const newItem = JSON.parse(JSON.stringify(item.attachment))
                    delete item.attachment.title
                    item.attachment.newTitle = newItem.title
                    attachment['ill' + desc].push(item)
                    item.explain = `图 ${desc}-${attachment['ill' + desc].length}`
                  }
                })
              }
            })
          }
          outline.children && this.reWbsAndGraphic(outline, outline.wbs, attachment)
        })
      }
      return outlines
    },
    // outline 树形结构降成一维数组
    makeOutline (brief) { // outline扁平化
      return brief.reduce((arr, { _id, brief, slide, children = [] }) =>
        arr.concat([{ _id, brief, slide }], this.makeOutline(children)), [])
    },
    // 创建图片目录
    creditLine (reportTree, list = []) {
      if (reportTree && reportTree.children.length > 0) {
        reportTree.children.map(outline => {
          if (outline && outline.slide && outline.slide.length > 0) {
            outline.slide.map(slide => {
              if (slide && slide.elements.length > 0) {
                slide.elements.map(attr => {
                  if ((attr.attachment._class === 0) || attr.attachment._class === 1 || attr.attachment._class === 2) {
                    list.push(attr)
                  }
                })
              }
            })
          }
          outline.children && this.creditLine(outline, list)
        })
      }
      return list
    },
    // 显示目录弹框
    goheader () {
      if (this.isShow) {
        this.showcss = 'fullwebpage-headers'
      }
    },
    // 隐藏目录弹框
    leaveheader () {
      if (this.isShow) {
        this.showcss = 'fullwebpage-header'
      }
    },
    changeHeader (data) {
      if (data) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  },
  watch: {

  }
}
</script>

<style scoped>
body {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}
.container {
  height: 100%;
}
.header {
  box-shadow: 0 2px 3px -1px gray;
  min-width: 1200px;
  display: flex;
  justify-content: center;
}
.main {
  padding: 0 !important;
  /* overflow-y: hidden; */
  width: 100%;
  min-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(250, 250, 250);
}
.header {
  color: #333;
  text-align: center;
  line-height: 60px;
  z-index: 1;
  border-bottom: 1px solid grey;
}
.headerline {
  width: 100%;
  height: 2px;
  min-width: 1200px;
  background-color: #e8e8e8;
  position: fixed;
  z-index: 3;
  top: 0;
}
#headerline {
  position: absolute;
  content: '';
  border-radius: 1px;
  height: 2px;
  background: #e8392a;
  width: 100%;
}
.fullwebpage-header {
  background: rgb(29, 29, 29);
  box-shadow: none;
  z-index: 666;
  position: fixed;
  width: 100%;
  transition: all 2.5s;
  opacity: 0;
}
.fullwebpage-headers {
  background: rgb(29, 29, 29);
  box-shadow: none;
  z-index: 666;
  position: fixed;
  width: 100%;
  transition: all 0.5s;
  opacity: 1;
  color: #c4c4c4 !important;
}
</style>
